goog.provide('el8.ext.onboarding.addlLabsDialog');

goog.require('el8.uiwidget.FormDialog');
goog.require('el8.template.ext.onboarding.addlLabsDialog');
goog.require('el8.ext.Form');
goog.require('el8.ext.onboarding.signupData');


el8.ext.onboarding.addlLabsDialog = (function() {

    var _saveCb = null;

    var that = new el8.uiwidget.FormDialog({
        height: 400,
        width: 500,
        modal: true,
        draggable: false,
        contentFn: el8.template.ext.onboarding.addlLabsDialog.content
    });

    var form = new el8.ext.Form({
        fields: [
            {
                name: 'addlLabs',
                selector: ':input[name="addlLabs"]',
                infoText: 'List your lab vendors here...',
                size: 'large',
                rows: 3
            }
        ]
    });
    form.addButton('save', 'Submit', function(_form) {
        var text = _form.getVal('addlLabs');
        el8.ext.onboarding.signupData.setAddlLabs(text);
        if (_saveCb) { _saveCb(text); }
        that.hide();
    }, true);
    form.addButton('cancel', 'Cancel', function(_form) {
        el8.ext.onboarding.signupData.setAddlLabs('');
        if (_saveCb) { _saveCb(''); }
        that.hide();
    }, false);

    that.setForm(form);

    var super_init = that._init;
    that._init = function() {
        super_init.call(that);
        that.getDialogContainer().addClass('el8OBDialog');
    };

    var super_show = that.show;
    that.show = function(spec) {
        spec = spec || {};
        _saveCb = spec.saveCb || null;
        super_show.call(that);
        form.setVal('addlLabs', el8.ext.onboarding.signupData.getAddlLabs());
        form.initFocus();
        // Give it better modal behavior
        $(document).on('click', '.ui-widget-overlay',  function(e) {
            that.hide();
        });
    };

    var super_hide = that.hide;
    that.hide = function() {
        super_hide.call(that);
        $(document).off('click', '.ui-widget-overlay');
    };

    return that;

})();
